// import {ThemeProvider} from 'styled-components'
import {Route, Routes} from 'react-router-dom'
import NavPage from './components/pages/NavPage';
import './App.css';

import LandingPage from './components/pages/LandingPage/LandingPage';
import UserSignUp from './components/pages/SignUp/User/SignUp';
import AdminSignUp from './components/pages/SignUp/Admin/SignUp';
import AdminLogin from './components/pages/Login/Admin/Login';
import UserLogin from './components/pages/Login/User/Login';
import UserReset from './components/pages/ForgotPassword/User/ForgotPassword';



function App() {
 
  
  return (
    
   <Routes>
		<Route path="/" element={<NavPage />} exact />
		<Route path="/landing" element={<LandingPage  />} />
		<Route path="/user/sign_up" element={<UserSignUp  />} /> 
		<Route path="/user/login" element={<UserLogin  />} /> 
		<Route path="/admin/sign_up" element={<AdminSignUp  />} /> 
		<Route path="/admin/login" element={<AdminLogin  />} /> 
		<Route path="/user/reset" element={<UserReset  />} /> 
	</Routes>
  );
}

export default App; 